import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Settings|Affiliation List|Search';

type LocNameStart = 'SPAffiliationListSearch';
export type SPAffiliationListSearchLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}CandidateIdFormat`
	| `${LocNameStart}FieldRequired`
	| `${LocNameStart}Name`
	| `${LocNameStart}Updated`
	| `${LocNameStart}Id`
	| `${LocNameStart}For`
	| `${LocNameStart}Criterion`
	| `${LocNameStart}Button`
	| `${LocNameStart}ClearButton`;

export const spAchievementSearchListLocs: LocDefs<SPAffiliationListSearchLocNames> = {
	SPAffiliationListSearchFieldRequired: {
		defaultValue: 'This field is required',
		description: 'Error shown when search criterion field is empty',
		displayPath: `${dpRoot}|Field Required`,
		displayType: 'Error',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchTitle: {
		defaultValue: 'Affiliations Search',
		description: 'Title for the affiliation search section',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchName: {
		defaultValue: 'Name',
		description: 'Label for Name in affiliation search dropdown',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchUpdated: {
		defaultValue: 'Updated',
		description: 'Label for Updated in affiliation search dropdown',
		displayPath: `${dpRoot}|Updated`,
		displayType: 'Label',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchId: {
		defaultValue: 'Affiliation ID',
		description: 'Label for Id in affiliation search dropdown',
		displayPath: `${dpRoot}|Id`,
		displayType: 'Label',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchCandidateIdFormat: {
		defaultValue: 'ID',
		description: 'Label for candidate ID field in affiliation search dropdown',
		displayPath: `${dpRoot}|Candidate ID`,
		displayType: 'Label',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchCriterion: {
		defaultValue: 'Criterion',
		description: 'Label for Criterion field in affiliation search dropdown',
		displayPath: `${dpRoot}|Criterion`,
		displayType: 'Label',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchFor: {
		defaultValue: 'For',
		description: 'Label for "For" field in the affiliation search dropdown',
		displayPath: `${dpRoot}|Web Group`,
		displayType: 'Label',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchButton: {
		defaultValue: 'Search',
		description: 'Button to run affiliation search',
		displayPath: `${dpRoot}|Search Button`,
		displayType: 'Button',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
	SPAffiliationListSearchClearButton: {
		defaultValue: 'Clear Search',
		description: 'Button to clear affiliation search results',
		displayPath: `${dpRoot}|Clear Search Button`,
		displayType: 'Button',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		portal: 'SP',
	},
};

export type SPSettingsTokenCountLocType = LocMap<SPAffiliationListSearchLocNames>;

export const LOC_KEYS = MapLocKeys<SPAffiliationListSearchLocNames>(spAchievementSearchListLocs);
